export default "__VITE_ASSET__Bu4B2ZUw__"